class RecruitButton {
  constructor(){
    const recruitButton = document.querySelector('.js-recruit-button');
    if(recruitButton){
      this.event(recruitButton);
    }
  }
  event(recruitButton) {
    gsap.to(recruitButton,{
      opacity: 0,
      pointerEvents: 'none',
      scrollTrigger: {
        trigger: '.js-footer',
        start: 'top bottom',
        end: 'top 80%',
        scrub: true
      }
    })
  }
}